module.exports = __webpack_public_path__ + "src/img/video.dbcf6d84.svg";